import { reactQueryClient } from '../../../web/ReactQueryProvider';
import { ITimeEntryFilter } from './types';

const BASE_QUERY_KEY = 'TimeEntry';

export const timeEntryKeys = {
	all: [BASE_QUERY_KEY] as const,
	day: (day: string) => [BASE_QUERY_KEY, 'day', day] as const,
	overdue: () => [BASE_QUERY_KEY, 'overdue'] as const,
	reviewQueue: () => [BASE_QUERY_KEY, 'reviewQueue'] as const,
	filter: (filter: ITimeEntryFilter) => [BASE_QUERY_KEY, 'filter', filter] as const,
	history: (id: string) => [BASE_QUERY_KEY, 'history', id] as const,
};

export function invalidateTimeEntries() {
	return reactQueryClient.invalidateQueries({ queryKey: timeEntryKeys.all });
}
